import { appstr } from "../utils/appstr";
import { GetUnknownErrorMessage } from "../utils/GetUnknownErrorMessage";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { WindowActivePoll } from "../utils/WindowActivePoll";
import { Globals } from "./Globals";

export class QGoogleAuthRFC extends QRFC {
  constructor() {
    super();
    this.fGoogleConsentWindow = null;
  }

  InitGoogleAuth(callbackObj) {
    this.fGoogleConsentWindow = window.open();
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  SetParams(org, user) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mode", "googleauth");
  }

  GetCallName() {
    return "qmongorfc";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var jsonResponse = JSON.parse(r);
    var window2 = this.fGoogleConsentWindow;
    if (jsonResponse["success"]) {
      // start listening for authentication callback so we can close google auth window
      var authURL = jsonResponse["auth_url"];
      window2.location = authURL;
      window.setInterval(WindowActivePoll, 100, window2);
    } else {
      // close google auth window
      window2.close();

      // cancel pending publish
      callBackObj.CancelAction();

      // throw contact support for help alert
      var alert = GetUnknownErrorMessage();
      var errAlert = new QAlert();
      errAlert.InitAlert(appstr("Alert"), alert, Globals._wsMgr.fBackgroundPanel, Globals._wsMgr);

      // render
      Globals._wsMgr.PrepRenderWS();
      Globals._wsMgr.RenderWS();
    }
  }
}
